import axios from 'axios';
import toast from 'react-hot-toast';

import { filterTypes } from '../../store/initData/mapFilters';
import { serviceTypes, services } from '../../store/initData/services';
import { apiUrl } from '../apiUrl';
import { fetchAcademy } from './academyModel';
import { fetchSummerplay } from './summerplayModel';

const fetchWorkshopsAll = async ({ franchiseId, levelId, locationId }) => {
  try {
    const queryUrl = `${apiUrl}/franchises/${franchiseId}/workshops?type=${
      levelId ?? ''
    }&location=${locationId ?? ''}`;

    const response = await axios.get(queryUrl);

    return response.data.workshop_occurrences || [];
  } catch (error) {
    toast.error(
      'Wystąpił problem pobierając lokalizacje warsztatów. Odśwież aplikację.',
    );

    return [];
  }
};

/* FOR ALL TYPES */
export const getWorkshops = async ({
  serviceValue,
  mapFilters,
  locationId,
  levelId,
  franchiseId,
}) => {
  console.log(serviceValue, mapFilters, locationId, levelId, franchiseId);
  let allWorkshops;
  switch (serviceValue) {
    case serviceTypes.workshop:
      allWorkshops = await fetchWorkshopsAll({
        franchiseId,
        levelId,
        locationId,
      });
      break;

    case serviceTypes.summerplay:
      allWorkshops = await fetchSummerplay({ franchiseId });
      break;

    case serviceTypes.academy:
      allWorkshops = await fetchAcademy({ franchiseId });
      break;

    default:
      allWorkshops = [];
      break;
  }

  return filterWorkshops({
    serviceValue: serviceValue,
    workshops: allWorkshops,
    mapFilters: mapFilters,
  });
};

const filterFreeVacancy = (workshops) =>
  workshops.filter((ws) => ws.signups < ws.places_total);
const filterFirstLesson = (workshops) =>
  workshops.filter((ws) => ws.show_lesson_time);
const filterDateAndHour = (workshops) =>
  workshops.filter(
    (ws) => ws.cyclic_day && +ws.cyclic_day > 0 && ws.cyclic_hour,
  );

export const filterWorkshops = ({ serviceValue, workshops, mapFilters }) => {
  let anyFilter = false;
  let result = [];

  const serviceFilterNames = services.find(
    (service) => service.value === serviceValue,
  ).mapFilters;

  mapFilters.forEach((filter) => {
    if (serviceFilterNames.includes(filter.slug) && filter.checked) {
      anyFilter = true;
      filter.slug === filterTypes.vacancy &&
        result.push(...filterFreeVacancy(workshops));
      filter.slug === filterTypes.firstLesson &&
        result.push(...filterFirstLesson(workshops));
      filter.slug === filterTypes.setDate &&
        result.push(...filterDateAndHour(workshops));
    }
  });

  !anyFilter && result.push(...workshops);

  return result;
};
